import { InputField, LabelField } from "components";
import { getCurrency } from "helper/numberFormat";
import React, { useEffect, useRef, useMemo, useState } from "react";
import thousands from "thousands";
import { CheckFloatValue } from "../../../../utils/functions";
import { MyCheckbox } from "components";

export const Cash = ({ formik, ...props }) => {
  const isOptionalObject = useMemo(() => {
    if (
      !Array.isArray(formik["values"]["allPaymentsMethods"]) ||
      formik["values"]["allPaymentsMethods"].length === 0
    )
      return;

    const currentComponent = formik["values"]["allPaymentsMethods"].find(
      (item) => {
        return item.type?.toLowerCase() === "cash";
      }
    );

    if (!currentComponent ||!currentComponent._id) return;

    return {
      id:currentComponent?._id,
      coverConvenienceFee: currentComponent?.coverConvenienceFee ?? false,
      isOptional: currentComponent?.convenienceFeeInfo?.optional ?? false,
      message: currentComponent?.convenienceFeeInfo?.message,
      type: currentComponent?.type,
    };
  }, [formik["values"]]);

   useEffect(() => {

      if (!isOptionalObject?.isOptional) return;

      if (!key) return;

      if (formik.values[key] === undefined) {

        formik.setFieldValue(key, true);

      }

    }, [key, isOptionalObject]);

  

  const key = `${isOptionalObject?.id}`;

  return (
    <>
      {isOptionalObject?.coverConvenienceFee && isOptionalObject?.isOptional && ( 
        <div
          className="right-side px-0 py-2"
          style={{
            minWidth: "216px",
            justifyContent: "flex-end",

    display: "flex",

    width: "89%",
          }}
        >
          <div className="d-flex align-items-center">
            <MyCheckbox
              name={key}
              checked={formik.values?.[key]}
              onClick={(e) => {
                formik.setFieldValue(key, e.target.checked);
              }}
              
            />
            <LabelField
              style={{ display: "flex", alignItems: "center", marginBottom: 0 }}
              title="Convenience Fee"
            />
          </div>
        </div>
      )}
    </>
  );
};
export const CashHeader = ({ formik, ...props }) => {
  const inputRef = useRef();
  const [state, setState] = useState(false);
  const { expanded, current, index } = props;

const currency = getCurrency();


  const preventMinus = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (e.currentTarget.value && e.currentTarget.value.length) {
        return;
      } else if (characterNumber === 0) {
        e.preventDefault();
      }
    } else {
      e.preventDefault();
    }
  };
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const handlefieldClick = (e) => {
    if (e.stopPropagation && expanded === true) {
      e.stopPropagation();
    }
  };
  const handleOnChange = (event) => {
    formik.setFieldValue("cash_payment", event.target.value.match(regex)[0]);
  };
  const getCommaSeperatedValue = (num) => {
    return CheckFloatValue(parseFloat(num?.toString().replace(/,/g, "")))
      ?.toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <div
      className={
        expanded === false && current?.includes("cash") === true
          ? "accordion-header"
          : expanded === false
            ? "accordion-payment-header"
            : expanded === true
              ? "accordion-header"
              : "accordion-header-payment"
      }
    >
      <LabelField title="Cash" />

      {
        console.log(formik.values?.cash, "formik.values?.cash", expanded, current?.includes("cash"), current)
      }

      <div
        className={
          expanded === false && current?.includes("cash")
            ? "custom-expand dollor-icon col-sm-3 nonexpanded-amount"
            : expanded === false &&
              current?.includes("cash") === false &&
              formik?.values?.cash_payment
              ? "custom-expand dollor-icon col-sm-3 nonexpanded"
              : "col-sm-3"
        }
      >
        {expanded === false &&
          current?.includes("cash") &&
          formik?.values?.cash_payment ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            {/* <span>{getCommaSeperatedValue(formik.values?.cash_payment)}</span> */}
            <span>{isNaN(formik.values?.cash_payment) ? "0.00" : thousands((+formik.values?.cash_payment).toFixed(2))}</span>
          </div>
        ) : current?.includes("cash") && expanded === true ? (
          <InputField
            {...{
              formik,
              title: "none",
              name: `val`,
              style: { background: "#ffff", border: "none" },
              value: formik.values?.cash_payment,
              placeholderIcon: (
                <span
                  className="align-self-center px-4"
                  style={{ color: "black" }}
                >
                  {currency}
                </span>
              ),
            }}
            paymentInput="paymentInput"
            // onKeyDown={preventMinus}
            handleFocus={(e) => handlefieldClick(e)}
            handleChange={(event) => handleOnChange(event)}
          />
        ) : expanded === false &&
          current?.includes("cash") === false &&
          formik?.values?.cash_payment ? (
          <div className="cash-non-expanded">
            <span>{currency}</span>
            <span>{isNaN(formik.values?.cash_payment) ? "0.00" : getCommaSeperatedValue(formik.values?.cash_payment)}</span>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
